module.exports = __webpack_public_path__ + "static/media/travel7.7d214d08.jpg";